var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iserrors) ? _c('div', {
    staticClass: "error-overlay"
  }, [_c('div', {
    staticClass: "error-message"
  }, [_c('h5', [_vm._v(_vm._s(_vm.errors))])])]) : _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isProductDetailsTableLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isProductDetailsTableLoading = $event
      }
    }
  }), _vm._v(" "), _c('legend', [_vm._v("Review RVP Shipments")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProductDetailsTable),
      expression: "showProductDetailsTable"
    }],
    staticClass: "card-headerfrm mb-3"
  }, [_c('div', {
    staticClass: "sr-container"
  }, [_c('label', {
    attrs: {
      "for": "srid"
    }
  }, [_vm._v("Sr Id: " + _vm._s(_vm.srid))]), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "srname"
    }
  }, [_vm._v("Sr Name: " + _vm._s(_vm.srname))])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables mt-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.productsArr.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((_vm.productsArr), function(data, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProductName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProductID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProductQty))]), _vm._v(" "), (_vm.isImagesAvailable) ? _c('td', _vm._l((data.PickupProductImage), function(image, idx) {
      return _c('a', {
        key: idx,
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.showPopup(image.ImageUrl, data.PickupProductImage, idx)
          }
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "Client Image",
          "alt": "Client Image"
        }
      })])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.isImagesAvailable) ? _c('td', [(data.SRPickDoneImages && data.SRPickDoneImages.length && data.SRPickDoneImages[0].value && data.SRPickDoneImages[0].ImageUrl) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col",
      staticStyle: {
        "width": "max-content"
      }
    }, [_c('div', {
      staticClass: "image-grid"
    }, _vm._l((data.SRPickDoneImages), function(image, idx) {
      return _c('a', {
        key: idx,
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.showPopup(image.ImageUrl, data.SRPickDoneImages, idx)
          }
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": image.value,
          "alt": "SR Image"
        }
      })])
    }), 0)])]) : _c('div', {
      staticClass: "row"
    }, _vm._l((data.SRPickDoneImages), function(image, idx) {
      return _c('a', {
        key: idx,
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.showPopup(image.ImageUrl, data.SRPickDoneImages, idx)
          }
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "SR Image",
          "alt": "SR Image"
        }
      })])
    }), 0)]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsArr.length > 0),
      expression: "productsArr.length > 0"
    }],
    staticClass: "row justify-content-between p-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-button', {
    staticClass: "btn btn-danger btn-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleReject()
      }
    }
  }, [_vm._v("Fail and\n                    Proceed")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-end"
  }, [_c('b-button', {
    staticClass: "btn btn-success btn-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleApprove()
      }
    }
  }, [_vm._v("Pass and\n                    Proceed")])], 1)])]), _vm._v(" "), (_vm.isPopupVisible) ? _c('div', {
    staticClass: "image-popup"
  }, [_c('div', {
    staticClass: "popup-content"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("X")]), _vm._v(" "), (_vm.popupImageIndex > 0) ? _c('button', {
    staticClass: "nav-btn left-btn",
    on: {
      "click": _vm.showPreviousImage
    }
  }, [_vm._v("<")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupImageUrl,
      "alt": "Popup Image"
    }
  }), _vm._v(" "), (_vm.popupImageIndex < _vm.currentImageSet.length - 1) ? _c('button', {
    staticClass: "nav-btn right-btn",
    on: {
      "click": _vm.showNextImage
    }
  }, [_vm._v(">")]) : _vm._e()])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepper-wrapper"
  }, [_c('div', {
    staticClass: "stepper-container"
  }, [_c('div', {
    staticClass: "step done"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Print Sticker")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "step done"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Inscan Flyer and AWB")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "step active"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Review")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Prod. Qty")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Product Images")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("SR Clicked Images")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9fd3d9","hasScoped":true}!./src/views/components/RVPPrintLabelReviewv2/RVPPrintLabelReviewv2.component.html
// module id = 1592
// module chunks = 1